import PropTypes from 'prop-types';
import cx from 'classnames';
import { v4 as uuid } from 'uuid';
import { Fragment } from 'react';
import Conditional from '../../Conditional';
import styles from './GstDisclaimer.module.scss';

const GstDisclaimer = ({ className = '', numberOfDaggers = 1, taxMessage }) => {
  const daggers = [...Array(numberOfDaggers)].map(() => (
    <Fragment key={`dagger${uuid()}`}>&dagger;</Fragment>
  ));
  return (
    <Conditional test={!!taxMessage}>
      <p className={cx(`mb-0 ${styles['attribute-text']}`, className)}>
        <sup className={`pe-1 ${styles['attribute-dagger']}`}>{daggers}</sup>
        {taxMessage}
      </p>
    </Conditional>
  );
};

GstDisclaimer.propTypes = {
  className: PropTypes.string,
  numberOfDaggers: PropTypes.number,
  taxMessage: PropTypes.string
};

export default GstDisclaimer;
